type PunkHighlightProps = {
  children: React.ReactNode
  colour?: 'chartreuse' | 'green' | 'purple'
  rotation?: string
  /**
   * 'stripe' (default) renders the punk marker-stripe behind the text,
   * suited to big bold headings. 'marker' swaps to a Strange Fresh marker
   * font with a neon glow, sized inline, suited to body-size text and
   * footer contexts where the stripe reads as a flat block.
   */
  variant?: 'stripe' | 'marker'
}

export function PunkHighlight({
  children,
  colour = 'chartreuse',
  rotation = '-1deg',
  variant = 'stripe',
}: PunkHighlightProps) {
  if (variant === 'marker') {
    return (
      <span className={`punk-marker punk-marker-${colour}`} style={{ rotate: rotation }}>
        {children}
      </span>
    )
  }
  return (
    <span
      className={`punk-highlight punk-highlight-${colour}`}
      style={{ transform: `rotate(${rotation})` }}
    >
      {children}
    </span>
  )
}
